import $$ from 'cmn-utils';

//获取组织机构列表
export async function qryOrgList(payload) {
  return $$.post('/org/qryOrgList', payload);
}

//新增组织机构
export async function addOrg(payload) {
  return $$.post('/org/addOrg', payload);
}

//删除组织机构
export async function delOrg(payload) {
  return $$.post('/org/delOrg', payload);
}

//编辑组织机构
export async function updateOrg(payload) {
  return $$.post('/org/updateOrg', payload);
}

//获取组织机构下对应的终端数量
export async function qryClientCountByOrgList(payload) {
  return $$.post('/org/qryClientCountByOrgList', payload);
}

//查询登录用户的父机构
export async function qryAuthClientNumsClientFlowDiskSpaceByUser(payload) {
	return $$.post('/org/qryAuthClientNumsClientFlowDiskSpaceByUser', payload);
}

//更新登录用户的终端授权，终端流量及磁盘空间
export async function updateAuthClientNumsClientFlowDiskSpaceByUser(payload) {
	return $$.post('/org/updateAuthClientNumsClientFlowDiskSpaceByUser', payload);
}




// WEBPACK FOOTER //
// ./src/routes/System/Org/service/index.js